document.addEventListener("DOMContentLoaded", () => {
  const tocBlocks = document.querySelectorAll(".toc-block-component")

  tocBlocks.forEach((tocBlock) => {

    /* =========================
       TOGGLE
    ========================== */

    const tocToggle = tocBlock.querySelector(".toc__toggle")
    const tocContent = tocBlock.querySelector(".toc__content")

    if (tocToggle && tocContent) {

      // The open/close animation is pure CSS (grid-template-rows 0fr -> 1fr), no height measuring.
      tocToggle.addEventListener("click", () => {
        const isOpen = tocBlock.classList.toggle("open")

        tocToggle.setAttribute("aria-expanded", String(isOpen))
      })
    }

    /* =========================
       HIGHLIGHT
    ========================== */

    if (tocBlock.dataset.highlight !== "true") return

    // Headings in document order, each with its TOC item (computed once, not on every scroll)
    const entries = Array.from(tocBlock.querySelectorAll(".toc__link"))
        .map(link => ({ heading: document.getElementById(link.dataset.target), item: link.parentElement, link }))
        .filter(entry => entry.heading)
        .sort((a, b) => (a.heading.compareDocumentPosition(b.heading) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1))

    if (!entries.length) return

    const scrollContainer = tocBlock.querySelector(".toc__list")
    let active = null
    let ticking = false

    // Keep the active item visible inside the (scrollable) TOC list
    function revealInList(link) {
      if (!scrollContainer || scrollContainer.scrollHeight <= scrollContainer.clientHeight) return
      if (tocBlock.dataset.collapsible === "true" && !tocBlock.classList.contains("open")) return

      const padding = 8
      const linkRect = link.getBoundingClientRect()
      const containerRect = scrollContainer.getBoundingClientRect()
      const linkTop = linkRect.top - containerRect.top
      const linkBottom = linkRect.bottom - containerRect.top

      if (linkTop < padding) {
        scrollContainer.scrollBy({ top: linkTop - padding, behavior: "smooth" })
      } else if (linkBottom > containerRect.height - padding) {
        scrollContainer.scrollBy({ top: linkBottom - containerRect.height + padding, behavior: "smooth" })
      }
    }

    function setActive(next) {
      if (next === active) return

      // Only the previous and the new item change; no loop over the whole list
      if (active) active.item.classList.remove("is-active")
      if (next) {
        next.item.classList.add("is-active")
        revealInList(next.link)
      }

      active = next
    }

    function updateActive() {
      ticking = false

      const offset = window.innerHeight * 0.3
      const atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2
      let current = null

      if (atBottom) {
        // The last heading may never reach the offset line on a short final section
        current = entries[entries.length - 1]
      } else {
        // Last heading that has already scrolled past the offset line
        for (let i = entries.length - 1; i >= 0; i--) {
          if (entries[i].heading.getBoundingClientRect().top <= offset) {
            current = entries[i]
            break
          }
        }
      }

      setActive(current)
    }

    // At most one update per frame instead of one per scroll event
    function requestUpdate() {
      if (ticking) return
      ticking = true
      requestAnimationFrame(updateActive)
    }

    window.addEventListener("scroll", requestUpdate, { passive: true })
    window.addEventListener("resize", requestUpdate, { passive: true })
    // Images and embeds change heading positions after the first paint
    window.addEventListener("load", requestUpdate)

    updateActive()
  })
})
